/**
 * Imported first in main.tsx, so it runs before the Supabase client starts and
 * restores a session: one past the inactivity or maximum limit is dropped
 * here (see src/lib/sessionPolicy.ts).
 */
import { expireStaleSessionOnBoot } from "./lib/sessionPolicy";

expireStaleSessionOnBoot();
